export const publicCommonProviders = (environment: PublicEnvironmentBase) => {
  if (!environment.envType?.length) {
    const origin = window.location.origin;
    if (window.location.origin.includes("staging")) {
      environment.envType = EnvironmentType.Staging;
    } else if (origin.includes("dev")) {
      environment.envType = EnvironmentType.Development;
    } else if (origin.includes("localhost")) {
      environment.envType = EnvironmentType.Local;
    } else {
      environment.envType = EnvironmentType.Production;
    }
  }

  return [
    {
      provide: "Window",
      useValue: window,
    },
    {
      provide: "envName",
      useValue: environment.envName,
    },
    {
      provide: "envType",
      useValue: environment.envType ? EnvironmentType[environment.envType] : null,
    },
    {
      provide: "customerPortalApiUrl",
      useValue: environment.customerPortalApiUrl,
    },
    {
      provide: "emailSignupWorkerUrl",
      useValue: environment.emailSignupWorkerUrl,
    },
    {
      provide: "supplierLeadWorkerUrl",
      useValue: environment.supplierLeadWorkerUrl,
    },
    {
      provide: "humanSpaceflightLeadWorkerUrl",
      useValue: environment.humanSpaceflightLeadWorkerUrl,
    },
    {
      provide: "midsouthFeedbackWorkerUrl",
      useValue: environment.midsouthFeedbackWorkerUrl,
    },
    {
      provide: "louisianaFeedbackWorkerUrl",
      useValue: environment.louisianaFeedbackWorkerUrl,
    },
    {
      provide: "hiringWorkerUrl",
      useValue: environment.hiringWorkerUrl,
    },
  ];
};

export const commonPublicTestProviders = (environment: EnvironmentBase) => {
  return [
    {
      provide: "envName",
      useValue: "test",
    },
    {
      provide: "envType",
      useValue: EnvironmentType.Test,
    },
  ];
};

export enum EnvironmentType {
  Local = "Local",
  Staging = "Staging",
  Production = "Production",
  Development = "Development",
  Test = "Test",
}

export interface PublicEnvironmentBase extends EnvironmentBase {
  customerPortalApiUrl: string;
  emailSignupWorkerUrl?: string;
  supplierLeadWorkerUrl: string;
  humanSpaceflightLeadWorkerUrl: string;
  midsouthFeedbackWorkerUrl?: string;
  louisianaFeedbackWorkerUrl?: string;
  hiringWorkerUrl?: string;
}

export interface EnvironmentBase {
  envName: string;
  envType?: keyof typeof EnvironmentType;
  production: boolean;
  cluster: string;
}
